import {ResourceData} from "../common/resource/resource-service";
import {ILocation} from "./location-models";

export class LocationData extends ResourceData<ILocation> {
    constructor() {
        super("/v5/locs");
    }
}
